import React from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

// Image
import tvc_Logo from "../photos/tvc_logo.png";

import loginCover from "../photos/login_cover.jpg";

export default function Register() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize useNavigate for redirect
  const [agreed, setAgreed] = useState(false);

  const [user, setUser] = useState({
    user_name: "",
    user_email: "",
    user_contact: "",
    user_password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);

  const handleClickShowConfirmPassword = () =>
    setConfirmShowPassword((show) => !show);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send a POST request to the backend
    axios
      .post(`${baseURL}/registerUser`, user, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        alert("User added successfully!");
        // Clear form inputs
        setUser({
          user_name: "",
          user_email: "",
          user_contact: "",
          user_password: "",
        });
        navigate("/auth/login");
        window.location.reload(); // Redirect to profile
      })
      .catch((error) => {
        alert("Error adding user");
      });
  };

  const [samePass, setSamePass] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [temp_pass, setTempPass] = useState("");

  useEffect(() => {
    // This effect will run every time inputValue changes
    if (temp_pass === confirmPassword) {
      setUser((prevUser) => ({ ...prevUser, user_password: confirmPassword }));
    } else {
    }
  }, [confirmPassword, temp_pass]);

  // const checkPassword = (event) => {
  //   setConfirmPassword(event);
  // };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div>
      <div className="Register full_Screen">
        {" "}
        <Stack
          direction={{ xs: "column", md: "row" }}
          minHeight="100dvh"
          sx={{
            backgroundImage: {
              xs: `url(${loginCover})`,
              md: "none",
            },
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Desktop image column */}
          <Box
            sx={{
              flex: 1,
              display: { xs: "none", md: "block" },
            }}
          >
            <Box
              component="img"
              src={loginCover}
              alt="loginCover"
              sx={{
                width: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: { xs: 2, sm: 3 },
              overflowY: "scroll", // Allows the background to scroll if the card is huge
            }}
          >
            {/* Card wrapper */}
            <Box
              sx={{
                width: "100%",
                maxWidth: 380,
                backgroundColor: "#fff",
                borderRadius: 3,
                boxShadow: {
                  xs: "0 8px 24px rgba(0,0,0,0.2)",
                  md: "none",
                },
                p: { xs: 3, sm: 4 },

                // --- THE FIX ---
                maxHeight: { xs: "85vh", md: "none" }, // Only limit height on mobile/tablet
                overflowY: "auto", // Enable scrolling

                // HIDE SCROLLBAR for Chrome, Safari and Opera
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                // HIDE SCROLLBAR for IE, Edge and Firefox
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              }}
            >
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1, width: "100%" },
                }}
                onSubmit={handleSubmit}
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"column"}
                noValidate
                autoComplete="off"
              >
                <Box
                  sx={{
                    "& > :not(style)": { width: "25ch" },
                  }}
                >
                  <img
                    src={tvc_Logo}
                    alt="The Vintage Collective"
                    onClick={handleClick}
                    style={{ cursor: "pointer" }}
                  />
                </Box>
                <b>Create an Account</b>
                <TextField
                  id="outlined-basic"
                  label="Name"
                  variant="outlined"
                  value={user.user_name}
                  onChange={(event) => {
                    setUser((prevUser) => ({
                      ...prevUser,
                      user_name: event.target.value,
                    }));
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  value={user.user_email}
                  onChange={(event) => {
                    setUser((prevUser) => ({
                      ...prevUser,
                      user_email: event.target.value,
                    }));
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Contact Number"
                  variant="outlined"
                  value={user.user_contact}
                  onChange={(event) => {
                    setUser((prevUser) => ({
                      ...prevUser,
                      user_contact: event.target.value,
                    }));
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  value={temp_pass}
                  onChange={(event) => {
                    setTempPass(event.target.value);
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />

                <TextField
                  id="outlined-basic"
                  label="Confirm Password"
                  variant="outlined"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(event) => {
                    setConfirmPassword(event.target.value);
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showConfirmPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <Box display="flex" justifyContent="center">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                        />
                      }
                      label={
                        <>
                          I agree to the website&nbsp;{" "}
                          <Link
                            to="/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </Link>{" "}
                          and{" "}
                          <Link
                            to="/terms-and-conditions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms and Conditions
                          </Link>
                        </>
                      }
                    />
                  </FormGroup>
                </Box>

                <Box sx={{ textAlign: "right" }}>
                  {" "}
                  <Link>Forgot Password?</Link>
                </Box>
                <Button variant="contained" type="Submit" disabled={!agreed}>
                  Sign up
                </Button>
                <span>
                  Existing user? <Link to={"/auth/login"}>Sign in here!</Link>
                </span>
              </Box>
            </Box>
          </Box>
        </Stack>
      </div>
    </div>
  );
}
